import type { SavedLocationApi, SavedLocationOption, SavedLocations, SavedLocationsFilters } from '../../models';

export const normalizeSavedLocation = (savedLocation: SavedLocationApi): SavedLocationOption => ({
  ...savedLocation,
  id: savedLocation.searchId,
  label: savedLocation.searchId,
});

export const normalizeSavedLocations = (savedLocations: SavedLocationApi[]): SavedLocations => {
  const list = savedLocations.map(normalizeSavedLocation).sort((a, b) => a.label.localeCompare(b.label));
  // TODO: ask back-end to remove duplicated search ids
  const uniqueList = [...new Map(list.map((location) => [location.searchId, location])).values()];

  return {
    list,
    map: uniqueList.reduce(
      (acc, location) => {
        acc[String(location.searchId)] = location;
        return acc;
      },
      {} as SavedLocations['map'],
    ),
  };
};

export const filterSavedLocations = (
  locations: SavedLocations,
  filters: Partial<SavedLocationsFilters> = {},
): SavedLocations => {
  const searchQuery = filters.search?.name?.trim().toLowerCase();

  const list = searchQuery
    ? locations.list.filter((location) => location.name.toLowerCase().includes(searchQuery))
    : locations.list;

  return {
    list,
    map: list.reduce(
      (acc, location) => {
        acc[location.id] = location;
        return acc;
      },
      {} as SavedLocations['map'],
    ),
  };
};
